/* ==========================================================================
   Product card — delegated AJAX add-to-cart
   Loaded by any section that renders the product-card snippet.
   Idempotent: guard prevents double-binding if the script loads twice.
   ========================================================================== */

(function () {
    if (window.__productCardInit) return;
    window.__productCardInit = true;

    var RESET_MS = 1800;

    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-product-card-add]');
        if (!btn || btn.disabled) return;

        e.preventDefault();

        var variantId = btn.dataset.variantId;
        if (!variantId) return;

        var labelEl = btn.querySelector('.product-card__cta-label');
        var originalLabel = labelEl ? labelEl.textContent : '';

        setLabel(btn, labelEl, 'Adding…');
        btn.disabled = true;

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ id: variantId, quantity: 1 })
        })
            .then(function (r) {
                if (!r.ok) throw new Error('Add to cart failed');
                return r.json();
            })
            .then(function () {
                btn.classList.add('is-added');
                setLabel(btn, labelEl, 'Added');
                refreshCartCount();
                document.dispatchEvent(new CustomEvent('cart:updated'));

                setTimeout(function () {
                    btn.classList.remove('is-added');
                    setLabel(btn, labelEl, originalLabel);
                    btn.disabled = false;
                }, RESET_MS);
            })
            .catch(function () {
                setLabel(btn, labelEl, 'Try again');
                setTimeout(function () {
                    setLabel(btn, labelEl, originalLabel);
                    btn.disabled = false;
                }, RESET_MS);
            });
    });

    function setLabel(btn, labelEl, text) {
        if (labelEl) {
            labelEl.textContent = text;
        } else {
            btn.textContent = text;
        }
    }

    function refreshCartCount() {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                document.querySelectorAll('.js-cart-count').forEach(function (el) {
                    el.textContent = cart.item_count;
                });
            })
            .catch(function () { /* no-op */ });
    }
})();
